


import http, { getBearerToken } from '@/http/service'

export default async (to, from, next) => {


   // next({ path: to.path })
  
   let token

   token = getBearerToken(process.env.VUE_APP_TOKEN_ADMIN)
   if (token != undefined) {
      http.defaults.headers.common['X-App'] = `sicovapp`
      http.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
   }  

   next()
}




